<template>
  <div>
    <section class="section max-w-800">
      <form v-on:submit.prevent="submit" class='forms'>
        <div class='forms'>
          <div
            v-if="errors.non_field_errors"
            class="form-control is-error col-tab-12 pb-20">
            <p
              v-for="(error, index) in errors.non_field_errors"
              :key="index"
              class="form-label is-error is-center-aligned">{{ error }}</p>
          </div>
          <VqInput
              classes="col-tab-12 pb-20"
              :label="$t('views.createPassword.form.password')"
              name="password"
              type="password"
              :errors="errors.new_password1"
              v-model="formData.new_password1"
          />
          <VqInput
              classes="col-tab-12"
              :label="$t('views.createPassword.form.confirm')"
              name="confirm_password"
              type="password"
              :errors="errors.new_password2"
              v-model="formData.new_password2"
          />
        </div>

        <div class="mt-20 row form-control">
          <button
            type="button"
            class="button is-small is-gray-400"
            @click="cancel">{{ $t('views.createPassword.form.cancel') }}
          </button>

          <button
            class="button is-small is-gamma"
            :class="{'is-loading': isFormLoading}"
          >{{ $t('views.createPassword.form.submit') }}
          </button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import HeaderSection from '@/components/HeaderSection.vue';
import VqInput from '@/components/VqInput.vue';

import AUTH from '@/api/auth';

export default {
  name: 'createPassword',
  components: {
    HeaderSection,
    VqInput,
  },
  data: () => ({
    formData: {},
    errors: {},
    isFormLoading: false
  }),
  computed: {
  },
  created() {
    this.passwordResetCheck();
  },
  mounted() {
  },
  methods: {

    passwordResetCheck() {
      AUTH.passwordResetCheck(this.$route.params).then(
        (res) => {
        },
        (err) => {
          this.$router.replace({ name: 'login', params: { locale: this.$i18n.locale } });
        },
      );
    },

    submit() {
      this.isFormLoading = true;
      this.errors = {};
      this.formData = Object.assign(this.$route.params, this.formData);
      AUTH.passwordResetConfirm(this.formData).then(
        (res) => {
          this.$router.replace({ name: 'login', params: { locale: this.$i18n.locale } });
        },
        (err) => {
          this.errors = err.response.data;
        },
      );
    },

    cancel() {
      this.$router.replace({ name: 'login', params: { locale: this.$i18n.locale } });
    },
  },
};
</script>
